// src/Dashboard/pages/user/Absences/components/AbsenceHistoryPreview.jsx

import React from "react";
import { FaClipboardList, FaRegClock } from "react-icons/fa";

import { splitNotes } from "../utils/absencesUtils";

export default function AbsenceHistoryPreview({ adherent, loading }) {
  const notes = splitNotes(adherent?.notes_adherent || "");

  return (
    <aside className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div className="border-b border-slate-200 bg-slate-50 px-4 py-4 dark:border-slate-800 dark:bg-slate-900/60">
        <div className="flex items-center gap-2">
          <FaClipboardList className="text-[#013E8E] dark:text-indigo-300" />

          <h2 className="text-base font-bold text-slate-900 dark:text-white">
            Historique
          </h2>
        </div>

        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          Dernières notes enregistrées sur la fiche.
        </p>
      </div>

      <div className="p-4">
        {loading ? (
          <div className="space-y-2">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="h-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800"
              />
            ))}
          </div>
        ) : !adherent ? (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-400">
            Sélectionnez un adhérent pour consulter son historique.
          </div>
        ) : notes.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-400">
            Aucun historique d’absence pour cet adhérent.
          </div>
        ) : (
          <div className="space-y-3">
            {notes.slice(0, 8).map((note, index) => (
              <div
                key={`${note}-${index}`}
                className="rounded-2xl border border-slate-200 bg-slate-50 p-3 dark:border-slate-700 dark:bg-slate-900/60"
              >
                <div className="mb-1 flex items-center gap-2 text-[11px] font-bold uppercase tracking-wide text-slate-400">
                  <FaRegClock />
                  Note #{notes.length - index}
                </div>

                <p className="text-sm leading-6 text-slate-700 dark:text-slate-200">
                  {note}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </aside>
  );
}